import { get } from 'svelte/store';
import { HTTPError } from 'ky';
import api from '$lib/services/kyAuthenticatedInstance';
import { variables } from '$lib/env';
import { userAccountStore } from '$lib/stores/auth-store';
import { setAppLoaderMessage } from '$lib/utils/app-loader';
import type { IMeResponseModel } from '$lib/models/IMeResponseModel';
import type { LayoutLoad } from './$types';

export const ssr = false;

/**
 * Assigning `location.href` only queues a navigation; the current task keeps
 * running. Returning or throwing here would let SvelteKit render a 500 in the
 * seconds before the browser unloads, so we hand off and never settle.
 */
const redirectToLogin = (url: URL): Promise<never> => {
	setAppLoaderMessage('Omdirigering til innlogging …');
	window.location.href = `${variables.api_baseurl}/account/login?returnUrl=${encodeURIComponent(
		url.pathname + url.search
	)}`;
	return new Promise<never>(() => {});
};

export const load: LayoutLoad = async ({ url }) => {
	if (url.pathname !== '/auth' && !get(userAccountStore)?.id) {
		try {
			const response = await api.get('Account/Me');
			const me: IMeResponseModel = await response.json();
			userAccountStore.set(me);
		} catch (error) {
			// 401 from the API, or a TypeError because fetch followed the API's 302
			// to Entra and was blocked by CORS. Both mean "no usable session".
			const noSession =
				error instanceof HTTPError ? error.response.status === 401 : error instanceof TypeError;
			if (noSession) return redirectToLogin(url);
			throw error;
		}
	}
	return {
		url: url.pathname
	};
};
